import {
  IMPERSONATION_TOKEN_STORAGE_KEY,
  TOKEN_STORAGE_KEY,
  USER_CACHE_STORAGE_KEY,
} from './auth-storage.constants';

/**
 * Accès au jeton de session, sans dépendance Angular (utilisable depuis les
 * services « feuilles » et le chargeur i18n).
 *
 * Un onglet de prise d'identité porte son propre jeton en sessionStorage : il
 * est prioritaire dans cet onglet et invisible des autres, dont la session
 * reste intacte.
 */
export function readStoredToken(): string | null {
  try {
    return (
      sessionStorage.getItem(IMPERSONATION_TOKEN_STORAGE_KEY) ||
      localStorage.getItem(TOKEN_STORAGE_KEY) ||
      sessionStorage.getItem(TOKEN_STORAGE_KEY)
    );
  } catch {
    return null;
  }
}

/**
 * Jeton de la session « non mémorisée » de cet onglet (« se souvenir de moi »
 * décoché) : jamais celui d'une prise d'identité ni celui du localStorage.
 */
export function readSessionToken(): string | null {
  try {
    return sessionStorage.getItem(TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

/** Range un jeton de session « non mémorisée » : il disparaît avec l'onglet. */
export function storeSessionToken(token: string): void {
  sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
}

export function isImpersonationSession(): boolean {
  try {
    return sessionStorage.getItem(IMPERSONATION_TOKEN_STORAGE_KEY) !== null;
  } catch {
    return false;
  }
}

export function storeImpersonationToken(token: string): void {
  sessionStorage.setItem(IMPERSONATION_TOKEN_STORAGE_KEY, token);
  // Le profil en cache est celui de l'utilisateur réel : l'onglet de prise
  // d'identité recharge le sien dans son propre stockage.
  sessionStorage.removeItem(USER_CACHE_STORAGE_KEY);
}

export function clearImpersonationSession(): void {
  sessionStorage.removeItem(IMPERSONATION_TOKEN_STORAGE_KEY);
  sessionStorage.removeItem(USER_CACHE_STORAGE_KEY);
}

/**
 * Stockage du profil en cache : isolé dans l'onglet pendant une prise
 * d'identité, pour ne pas écraser (ni diffuser aux autres onglets) le profil
 * de l'utilisateur réel.
 */
export function userCacheStorage(): Storage {
  return isImpersonationSession() ? sessionStorage : localStorage;
}
